import React, { useContext, useState, useEffect } from "react";
import { DContext } from "../../../context/Datacontext";
import { FiLinkedin, FiGithub, FiYoutube, FiGlobe } from "react-icons/fi";

export const SocialLinks = () => {
    const { BeURL, instructor, setInstructor } = useContext(DContext);

    const [form, setForm] = useState({
        linkedin: "",
        github: "",
        youtube: "",
        website: "",
    });

    const [loading, setLoading] = useState(false);

    // ✅ Load existing social links
    useEffect(() => {
        if (instructor?.social) {
            setForm({
                linkedin: instructor.social.linkedin || "",
                github: instructor.social.github || "",
                youtube: instructor.social.youtube || "",
                website: instructor.social.website || "",
            });
        }
    }, [instructor]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // ✅ URL validation
    const isValidURL = (url) => {
        if (!url) return true; // allow empty
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate URLs
        for (const key in form) {
            if (!isValidURL(form[key])) {
                alert(`Invalid URL in ${key}`);
                return;
            }
        }

        try {
            setLoading(true);

            const res = await fetch(
                `${BeURL}/update/instructor/profile/social-links`,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ social: form }),
                }
            );

            if (!res.ok) throw new Error("Server error");

            const data = await res.json();

            if (data.success) {
                alert("Social Links Updated Successfully");
                setInstructor(data.updatedInstructor); // update context
            } else {
                alert(data.message || "Update failed");
            }
        } catch (err) {
            console.error("SOCIAL ERROR:", err);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-5xl bg-white p-6 rounded-xl shadow-sm">
            <h2 className="text-xl font-semibold mb-6">Social Links</h2>

            <form onSubmit={handleSubmit} className="space-y-5">

                {/* LINKEDIN */}
                <div className="flex items-center gap-3 border rounded-lg px-3 py-2">
                    <FiLinkedin className="text-blue-600" />
                    <input
                        name="linkedin"
                        placeholder="LinkedIn URL"
                        value={form.linkedin}
                        onChange={handleChange}
                        className="w-full outline-none"
                    />
                </div>

                {/* GITHUB */}
                <div className="flex items-center gap-3 border rounded-lg px-3 py-2">
                    <FiGithub className="text-gray-800" />
                    <input
                        name="github"
                        placeholder="GitHub URL"
                        value={form.github}
                        onChange={handleChange}
                        className="w-full outline-none"
                    />
                </div>

                {/* YOUTUBE */}
                <div className="flex items-center gap-3 border rounded-lg px-3 py-2">
                    <FiYoutube className="text-red-500" />
                    <input
                        name="youtube"
                        placeholder="YouTube URL"
                        value={form.youtube}
                        onChange={handleChange}
                        className="w-full outline-none"
                    />
                </div>

                {/* WEBSITE */}
                <div className="flex items-center gap-3 border rounded-lg px-3 py-2">
                    <FiGlobe className="text-green-600" />
                    <input
                        name="website"
                        placeholder="Personal Website"
                        value={form.website}
                        onChange={handleChange}
                        className="w-full outline-none"
                    />
                </div>

                {/* SAVE BUTTON */}
                <button
                    type="submit"
                    disabled={loading}
                    className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg transition disabled:opacity-50"
                >
                    {loading ? "Saving..." : "Save Social Links"}
                </button>
            </form>
        </div>
    );
};
